import React from "react";

import { MarkdownRenderer } from "@agent-ui/features/chat/components/chat-elements/chat-message/MarkdownRenderer";
import twMerge from "@replo/design-system/utils/twMerge";

export const TextMessage = ({ text, role }: { text: string; role: string }) => {
  return (
    <div
      className={twMerge(
        "text-sm relative [word-break:break-word] text-default max-w-full",
        role === "user"
          ? "px-3 py-2 bg-surface rounded-2xl rounded-tr-sm ml-auto"
          : "rounded-lg",
      )}
    >
      <MarkdownRenderer>{text}</MarkdownRenderer>
    </div>
  );
};
